
import { Drawer, Input, Select, Option, Switch } from "element-ui"
import editAddress from "@/components/drawer/editAddress.vue"
import { deleteAddress } from "@/api/address"
export default {
  components: {
    [Drawer.name]: Drawer,
    [Input.name]: Input,
    [Select.name]: Select,
    [Option.name]: Option,
    [Switch.name]: Switch,
    editAddress
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    addressList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      editVisible: false,
      drawer: this.visible,
      // activeSaveBtn: false,
      addressListCuurent: [],
      addresses: {},
      action: ""
    }
  },
  computed: {
    activeSaveBtn() {
      // 至少有 2 条地址，且有一条被选中
      return this.addressListCuurent.length >= 2 && this.addressListCuurent.some(item => item.checked)
    }
  },

  watch: {
    visible(val) {
      this.drawer = val
    },
    addressList(val) {
      this.addressListCuurent = val
      this.addressListCuurent.map(val => {
        if (val.priority) {
          val.checked = true
          return val
        } else {
          val.checked = false
          return val
        }
      })
    }
  },
  mounted() {
    // this.activeSaveBtn = this.addressListCuurent.some(item => item.checked)
  },
  methods: {
    saveAddress() {
      this.editVisible = false
      this.$emit("saveAdd", {})
    },
    closeEdit() {
      this.editVisible = false
    },
    editChange(item, type) {
      if (type === "edit") {
        this.editVisible = true
        this.addresses = item
        this.action = "edit"
        console.log(this.addresses, "this.addressesthis.addresses")
      } else {
        this.$emit("remove", item)
      }
    },
    handleClose() {
      this.$emit("close", false)
    },
    handleSave() {
      this.$emit("save", this.addressListCuurent.filter(val => val.checked)[0])
    },
    slectAddress(item) {
      this.addressListCuurent = this.addressListCuurent.map(val => {
        return {
          ...val, // 展开原对象
          checked: val.id === item.id // 仅修改 checked 字段
        }
      })
      // this.activeSaveBtn = true
    },
    addMyAddress() {
      this.action = "add"
      this.editVisible = true
    }
  }
}
